import { IDashboardComponent } from "api/model/dashboard/DashboardComponent";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import React from "react";
import { T } from "services/lang/LanguageService";
import { ComponentTheme } from "utils/enums";

interface ComponentThemeEditorProps {
  currentConfig: IDashboardComponent;
  setCurrentConfig: (currentConfig: IDashboardComponent) => void;
}

export const componentThemeOptions = [
  { label: T("theme.light"), value: ComponentTheme.LIGHT },
  { label: T("theme.dark"), value: ComponentTheme.DARK },
  { label: T("theme.transparent"), value: ComponentTheme.TRANSPARENT },
];

const ComponentThemeEditor = ({ currentConfig, setCurrentConfig }: ComponentThemeEditorProps) => {
  const handleThemeChange = (e: DropdownChangeEvent) => {
    const updatedConfig = {
      ...currentConfig,
      config: {
        ...currentConfig.config,
        theme: e.value,
      },
    };
    setCurrentConfig(updatedConfig);
  };

  return (
    <div className="p-col w-4">
      <label htmlFor="theme">{T("label.component-theme")}</label>
      <Dropdown
        value={currentConfig?.config?.theme ?? ComponentTheme.LIGHT}
        options={componentThemeOptions}
        onChange={handleThemeChange}
        optionLabel="label"
        optionValue="value"
        placeholder={T("action.select-a-component-theme")}
      />
    </div>
  );
};

export default ComponentThemeEditor;
